import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Moment from "moment";

@inject("UserStore")
@observer
class Downloads extends Component {
  componentDidMount() {
    this.props.UserStore.getMyOrders();
    this.props.UserStore.getMyDownloads();
  }

  render() {
    return (
      <div className="history">
        <div className="head-entry entry">
          <p>Item</p>
          <p>Price</p>
          <p>Date Bought</p>
          <p>Download</p>
        </div>
        {this.props.UserStore.downloads.map(order => (
          <div className="entry" key={order._id}>
            <p>{order._product.name}</p>
            <p>${order.productPrice}</p>
            <p
              style={{
                textTransform: "capitalize"
              }}
            >
              {Moment(order.createdAt).format("MM/DD/YYYY")}
            </p>
            <p>
              <a href={order.link} className="blue-btn">
                DOWNLOAD
              </a>
            </p>
          </div>
        ))}
      </div>
    );
  }
}

export default Downloads;



// WEBPACK FOOTER //
// ./src/components/Downloads.js